<template>
  <b-nav-item-dropdown
    right
    variant="link"
    size="lg"
    class="nav-item user">
    <template slot="button-content" >
      <b-row>
        <b-col
          md="9">
          <div>{{ name }}</div>
          <div class="user-position">{{ position }}</div>
        </b-col>
        <b-col
          md="2"
          class="p__l--2 p__r--1">
          <img
            v-if="img"
            :src="img"
            class="round-bordered-img-small">
          <div
            v-else
            class="img-responsive-nav round-bordered-img-nav"/>
        </b-col>
        <b-col
          md="1"
          class="p__l--1 m__t--17">
          <span class="caret pull-right"/>
        </b-col>
      </b-row>
    </template>

    <span
      v-for=" menu in submenu.menus"
      :key="menu.id" >
      <b-dropdown-header
        v-if="menu.title"> {{ menu.title }}
      </b-dropdown-header>
      <b-dropdown-item
        v-if="menu.href !== undefined"
        :to="menu.href"
        class="dropdown-item"> {{ menu.text }}
      </b-dropdown-item>
      <b-dropdown-item
        v-else
        :href="menu.hrefout"
        class="dropdown-item"> {{ menu.text }}
      </b-dropdown-item>
    </span>
  </b-nav-item-dropdown>
</template>

<script>
// import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown';
// import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
// import bDropdownHeader from 'bootstrap-vue/es/components/dropdown/dropdown-header';
/* eslint linebreak-style: ["error", "windows"] */
export default {
  name: 'JNavItemUser',
  components: {
    // bNavItemDropdown, bDropdownItem, bDropdownHeader,
  },
  props: {
    submenu: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      name: localStorage.getItem('full_name'),
      position: localStorage.getItem('username'),
      img: localStorage.getItem('photo'),

    };
  },

};
</script>

<style scoped>
  .user-name {
    font-size: 14px;
    line-height: 14px;
  }

  .user-position {
    font-size: 10px;
    font-family: Gotham-Book;
  }

  .caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid \9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }

  .img-responsive-nav {
    display: block;
    max-width: 100%;
  }

  .round-bordered-img-nav {
    float: left!important;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    margin-right: 5px;
    margin-top: 5px;
    background-image: url('../../assets/image/profile.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/navbar/jNavItemUser.vue